<template>
  <div class="row">
    <div v-if="document" class="col-xs-12 well" >

     <div class="clearfix"></div>
      <div class="row">
        <div class="panel-tools">
          <div class="btn-group">
            <!--<button class="btn btn-xs btn-info btn-outline" title="Edit"
                    @click="modalAction = 'edit'"><i class="fas fa-pencil-alt"></i> <span class="hidden-xs hidden-md">Edit</span>
            </button>-->
            <button class="btn btn-xs btn-danger btn-outline" title="remove"
                    v-on:click="removeDocument($event,document.id)"><i class="fa fa-remove"> Remove</i>
            </button>
          </div>
        </div>
      </div>
      <div class="row"  style="margin-top: 10px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <strong>Title : </strong>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <span v-html="document.title"></span>
        </div>
      </div>
      <div class="row" style="padding-top: 10px" v-if="document.authorsDetails">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <strong>Authors : </strong>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <template v-for="(coAuthor, key) in document.authorsDetails">
            <template v-if="key > 0">, </template>
            {{coAuthor.lastName}} {{coAuthor.firstName}}
            <template v-if="key === (document.authorsDetails.length - 1) ">. </template>
          </template>
        </div>
      </div>
      <div class="row"  style="margin-top: 10px" v-if="document.doi">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <strong>Doi : </strong>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <span v-html="document.doi"></span>
        </div>
      </div>
      <div class="row" style="padding-top: 10px">
        <div class="col-md-2 col-xs-12 col-sm-3 item-label">
          <strong>Publication Year : </strong>
        </div>
        <div class="col-md-10 col-xs-12 col-sm-9">
          <span> {{ new Date(document.date).getFullYear()}}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Document',
  components: {},
  props: ['value', 'removeDocument'],
  watch: {
    value: function (val) {
      this.document = val
    }
  },
  data () {
    return {
      document: null,
      modalAction: null
    }
  },
  beforeMount () {
    this.document = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/Document.vue